export function updateTitle(title: string) {
  document.title = title
}
